__turbopack_context__.v({
  "blur": "Menu-module___Z9Bfq__blur",
  "cardImageWrapper": "Menu-module___Z9Bfq__cardImageWrapper",
  "container": "Menu-module___Z9Bfq__container",
  "fadeBg": "Menu-module___Z9Bfq__fadeBg",
  "hidden": "Menu-module___Z9Bfq__hidden",
  "logo": "Menu-module___Z9Bfq__logo",
  "menu": "Menu-module___Z9Bfq__menu",
  "menuControls": "Menu-module___Z9Bfq__menuControls",
  "nav": "Menu-module___Z9Bfq__nav",
  "queueButton": "Menu-module___Z9Bfq__queueButton",
  "result": "Menu-module___Z9Bfq__result",
  "resultInfo": "Menu-module___Z9Bfq__resultInfo",
  "results": "Menu-module___Z9Bfq__results",
  "resultsWrapper": "Menu-module___Z9Bfq__resultsWrapper",
  "searchControls": "Menu-module___Z9Bfq__searchControls",
  "selectedBar": "Menu-module___Z9Bfq__selectedBar",
  "sideControls": "Menu-module___Z9Bfq__sideControls",
});
